import { useMemo } from 'react';
import sortBy from 'lodash/sortBy';
import { flattenNodes } from '../../lib/flattenNodes';
import { type TreeEditorProps } from './types';

export function useTreeEditorRows<Attributes>({ data, onGetItemIds, sortByKeys }: TreeEditorProps<Attributes>) {
    return useMemo(() => {
        const sortedItems = sortBy<Attributes>(data, sortByKeys);

        return flattenNodes<Attributes>(sortedItems, onGetItemIds).rows;
    }, [data, onGetItemIds, sortByKeys]);
}
